exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\na[data-v-d086789a] {\n  color: #222c3c;\n}\n.loaderArea[data-v-d086789a] {\n  height: 300px;\n}\n.agentInfoTop[data-v-d086789a] {\n  height: 200px;\n}\n.agentInfoTop .imageHolder img[data-v-d086789a] {\n    max-width: 100%;\n}\n.agentInfoTop .imageHolder i.fas[data-v-d086789a] {\n    font-size: 6rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-d086789a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/tools/modal/agentUnknownView.vue
// module id = 2284
// module chunks = 0